export const ONEMAP_API_URL = process.env.REACT_APP_ONEMAP_URL;
export const ONEMAP_SEARCH_ADDRESS_API_URL = `${ONEMAP_API_URL}/common/elastic/search`;
